import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=2407913b&scoped=true"
import script from "./recycle.vue?vue&type=script&lang=js"
export * from "./recycle.vue?vue&type=script&lang=js"
import style0 from "./recycle.vue?vue&type=style&index=0&id=2407913b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407913b",
  null
  
)

export default component.exports